import { IconButton } from "@mui/material";
import { useColorScheme } from "@mui/material/styles";
import { Box } from "@mui/system";

import { DarkModeIcon, LightModeIcon } from "../components/Icons/Icons";

export function ThemeToggle() {
  const { mode, setMode } = useColorScheme();
  return (
    <>
      <Box
        sx={{
          position: "relative",
          width: 100,
          height: 50,
          backgroundColor: "transparent",
          borderRadius: "999px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "4px",
          boxSizing: "border-box",
          border: "2px solid var(--mui-palette-primary-main)",
          "[data-mui-color-scheme='dark'] &": {
            border: "2px solid var(--mui-palette-primary-light)",
          },
        }}
      >
        {/* Sliding background */}
        <Box
          sx={{
            position: "absolute",
            top: 2,
            left: mode === "light" ? 2 : "calc(50% + 3px)",
            width: "calc(50% - 5px)",
            height: "calc(100% - 4px)",
            borderRadius: "999px",
            transition: "left 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
            zIndex: 1,
            backgroundColor: "primary.main",
            "[data-mui-color-scheme='dark'] &": {
              backgroundColor: "primary.light",
            },
          }}
        />

        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            position: "relative",
            zIndex: 2,
          }}
        >
          <IconButton onClick={() => setMode("light")} aria-label="Switch to Light Mode" sx={{ padding: "7px" }}>
            <LightModeIcon
              sx={{
                color: mode === "light" ? "secondary.contrastText" : "primary.main",
                transition: "color 0.3s ease-in-out",
                "[data-mui-color-scheme='dark'] &": {
                  color: mode === "light" ? "secondary.contrastText" : "primary.light",
                },
              }}
            />
          </IconButton>

          <IconButton onClick={() => setMode("dark")} aria-label="Switch to Dark Mode" sx={{ padding: "7px" }}>
            <DarkModeIcon
              sx={{
                color: mode === "dark" ? "secondary.contrastText" : "primary.main",
                transition: "color 0.3s ease-in-out",
                "[data-mui-color-scheme='dark'] &": {
                  color: mode === "dark" ? "secondary.contrastText" : "primary.light",
                },
              }}
            />
          </IconButton>
        </Box>
      </Box>
    </>
  );
}
